import *as _ from 'lodash'
import {ModelTermBO} from "./ModelTermBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ModelBO} from "./ModelBO";
import {
    WB_ModelCannibalizationRelationshipRow, WB_ModelCannibalizationTypeRow, WB_ModelingSessionCannMRRow,
    WB_ModelPredictorRelationshipRow, WB_PowerMetricRelationshipRow,
    WB_PowerMetricRow
} from "../PA.Core/PAdbSchemaRows";
import {esWB_AffinityGroup, esWB_Power_Metric_Relationship} from "../PA.Core/PAdbSchema";
import {ModelCannibalizationTypeBO} from "./ModelCannibalizationTypeBO";

export class ModelCannibalizationTypeBOValidations {

    static Validate(aBO: ModelCannibalizationTypeBO): Promise<void> {

        return new Promise<void>((resolve, error) => {

                let custCannMethod: string = aBO.WB_ModelCannibalizationType.cif.CUSTOMER_CANN_METHOD
                let prdCannMethod: string = aBO.WB_ModelCannibalizationType.cif.PRODUCT_CANN_METHOD
                let timeCannMethod: string = aBO.WB_ModelCannibalizationType.cif.TIME_CANN_METHOD
                if(timeCannMethod === 'AcrossPeriods'){
                    if(custCannMethod === 'AcrossCustomers' || prdCannMethod === 'AcrossProducts') {
                        aBO.ValidateMessageProvider.addMessage(
                            {
                                code: 'acrossPeriods',
                                type: MessageType.Error,
                                title: `Different Retailer or Different Products are not allowed while "Across Time Period" is selected.`,
                                description: "",
                                subtitle: "",
                                count: 0
                            })

                    }

                }

            resolve()

        })

    }
}